<template>
  <ORow fill-x top>
    <div class="oderon-col-6">
      <label class="light-caption">Input</label>
      <textarea
        ref="theInput"
        rows="20"
        class="miniparser-input mono"
        v-model="hexInput"
      />
      <div v-if="selLength != null">{{ selLength }} chars selected.</div>
    </div>
    <div class="oderon-col-6">
      <label class="light-caption">Output</label>
      <OutputLine v-for="(line, i) of outputLines" :key="i" :line="line" />
    </div>
  </ORow>
</template>

<script>
import OutputLine from './OutputLine.vue'

export default {
  components: { OutputLine },
  props: {
    value: {}
  },
  data() {
    return {
      selLength: null,
      hexInput: this.value || ''
    }
  },
  computed: {
    outputLines() {
      return this.hexInput.split('\n').map((x) => x.trim().toLowerCase())
    }
  },
  watch: {
    value() {
      this.hexInput = this.value
    }
  },
  mounted() {
    this.selectionListener = (evt) => {
      const start = evt.target.selectionStart
      const end = evt.target.selectionEnd
      this.selLength = end - start
    }

    this.$refs.theInput.addEventListener('select', this.selectionListener)
  },
  beforeDestroy() {
    this.$refs.theInput.removeEventListener('select', this.selectionListener)
  }
}
</script>

<style lang="sass">
.miniparser-input
  width: 100%
  font-size: 14px
  line-height: 20px
  // text-align: right
  outline: none
</style>
